var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessfulRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2667 19.3882L19.1725 24.3772C19.9565 25.1745 21.2419 25.1741 22.0255 24.3763L32.4062 13.8068M39.7764 22.1431V9.43931C39.7764 8.58473 39.2334 7.82457 38.425 7.54741L22.8991 2.22424C22.4754 2.07896 22.0152 2.08013 21.5922 2.22756L6.34174 7.54307C5.53831 7.82311 5 8.5808 5 9.43164V22.1431C5.00007 32.636 15.592 39.3412 21.6572 41.7723C22.0384 41.9251 22.4581 41.9488 22.8504 41.8275C28.8187 39.9826 39.7764 32.5495 39.7764 22.1431Z",
    stroke: "#12AC21",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessfulRequest);
export default __webpack_public_path__ + "static/media/SuccessfulRequest.9ae320a792b8542c98e3784162c3552c.svg";
export { ForwardRef as ReactComponent };